import React from 'react';
import { Table } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import RequestWorkspaceStatusButton from './RequestWorkspaceStatusButton';

const RequestWorkspaceCell = ({ request }) => {
  const hasUrl = hasMinimumLength(request.workspace_inbox_url);

  return (
    <Table.Cell className="aridhia-request-workspace-cell">
      {hasUrl && (
        <a href={request.workspace_inbox_url} target="_blank" rel="noopener noreferrer">
          {request.workspace_name}
        </a>
      )}
      {!hasUrl && (<RequestWorkspaceStatusButton request={request} className="aridhia-cell-button" />)}
    </Table.Cell>
  );
};

export default RequestWorkspaceCell;
